// removed by extract-text-webpack-plugin
module.exports = {"Search":"_2v8xcsleJxFOuu36UaEv3x","TextField":"_1Ua0KRDVZWC4aqf61savCU","SearchContainer":"_2rqf5lGMJeFFKgucCCuFsg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Search.css
// module id = 1371
// module chunks = 0